import * as React from "react";
import { forwardRef } from "react";
const SvgIconForm = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 14, height: 14, "data-name": "icon/form", viewBox: "0 0 14 14", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M7 14H0V0h14v14zM1.354 7v5.647h11.293V1.353H1.354zm7.234 4.47H5.706V7.588h5.765v3.883zM7 9.53v.589h3.118V8.941H7zm-3.5.647h-.97V8.882h1.94v1.294zm5.088-3.765H5.706V2.529h5.765v3.883zM7 4.47v.589h3.118V3.882H7zm-3.5.647h-.97V3.823h1.94v1.295z", "data-name": "icon_form", fill: "#2d98da" }));
const ForwardRef = forwardRef(SvgIconForm);
export { ForwardRef as ReactComponent };
